/**
 * IdeaDetail Screen Styles
 * Extracted per Cursor Rules (<300 lines per file)
 */

import { StyleSheet } from 'react-native';
import { color, text, space, radius, icon, layout } from '../../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  scroll: {
    flex: 1,
  },
  scrollContent: {
    padding: space.md,
    paddingBottom: layout.scrollBottomPadding,
    gap: space.md,
  },
  centerContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: space.lg,
  },
  errorText: {
    fontSize: text.body.fontSize,
    color: color.textSecondary,
    marginTop: space.md,
    textAlign: 'center',
  },
  retryButton: {
    marginTop: space.md,
    paddingVertical: space.sm,
    paddingHorizontal: space.lg,
    backgroundColor: color.primary,
    borderRadius: radius.md,
  },
  retryButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: '600',
    color: color.surface,
  },

  // Header Card
  headerCard: {
    backgroundColor: color.surface,
    borderRadius: radius.lg,
    borderWidth: 1,
    borderColor: color.border,
    padding: space.md,
    gap: space.md,
  },
  badgeRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: space.xs,
  },
  categoryBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: space.sm,
    paddingVertical: 4,
    borderRadius: radius.full,
  },
  statusBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: space.sm,
    paddingVertical: 4,
    borderRadius: radius.full,
  },
  priorityBadge: {
    paddingHorizontal: space.sm,
    paddingVertical: 4,
    borderRadius: radius.full,
  },
  badgeText: {
    fontSize: 12,
    fontWeight: '600',
  },
  title: {
    fontSize: text.sectionTitle.fontSize,
    fontWeight: text.sectionTitle.fontWeight,
    lineHeight: text.sectionTitle.lineHeight,
    color: color.textPrimary,
  },
  description: {
    fontSize: text.body.fontSize,
    lineHeight: text.body.lineHeight,
    color: color.textSecondary,
  },
  authorRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.sm,
    paddingTop: space.sm,
    borderTopWidth: 1,
    borderTopColor: color.divider,
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: color.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarText: {
    fontSize: text.body.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
  authorName: {
    fontSize: text.body.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.textPrimary,
  },
  authorDate: {
    fontSize: text.caption.fontSize,
    color: color.textMuted,
  },
  resolutionCard: {
    backgroundColor: color.backgroundSecondary,
    borderRadius: radius.md,
    padding: space.md,
  },
  resolutionLabel: {
    fontSize: text.caption.fontSize,
    fontWeight: '600',
    color: color.textMuted,
    marginBottom: space.xs,
  },
  resolutionText: {
    fontSize: text.body.fontSize,
    color: color.textSecondary,
    lineHeight: text.body.lineHeight,
  },
  resolverText: {
    fontSize: text.caption.fontSize,
    color: color.textMuted,
    marginTop: space.sm,
    fontStyle: 'italic',
  },

  // Tab Bar
  tabBar: {
    flexDirection: 'row',
    backgroundColor: color.surface,
    borderRadius: radius.lg,
    borderWidth: 1,
    borderColor: color.border,
    overflow: 'hidden',
  },
  tab: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: space.xs,
    paddingVertical: space.md,
  },
  tabActive: {
    backgroundColor: color.primaryLight,
  },
  tabText: {
    fontSize: text.body.fontSize,
    color: color.textMuted,
  },
  tabTextActive: {
    color: color.primary,
    fontWeight: '600',
  },

  // Tab Content
  tabContent: {
    minHeight: 200,
  },
});

